/* Warenkorb-Drawer: öffnet nach dem Hinzufügen, Menge ändern, Position entfernen, Meldungen, Fokus.
   Die API steckt in cart.js, Geschenk, Notiz und der Vorschlag laden in cart-extras.js. Der Inhalt wird vom Server neu gerendert (Section cart-drawer). */
(() => {
  const FW = window.Forstwald;
  if (!FW || !FW.cart || customElements.get('fw-cart-drawer')) return;
  const str = () => FW.strings || {};
  const fill = (tpl, map) => (tpl || '').replace(/%(\w)/g, (m, k) => (map[k] !== undefined ? map[k] : m));

  class FwCartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.error = this.querySelector('[data-cart-error]');
      this.live = this.querySelector('[data-cart-live]');
      if (!this.dialog || this.ready) return;
      this.ready = true;
      this.addEventListener('change', (e) => {
        const input = e.target.closest('[data-cart-qty]');
        if (!input) return;
        const line = input.closest('[data-line-key]');
        const qty = parseInt(input.value, 10);
        this.run(FW.cart.change(line.dataset.lineKey, Number.isNaN(qty) ? 1 : qty), () => fill(str().quantity_updated, { t: line.dataset.title, q: qty }));
      });
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-cart-remove]');
        if (!btn) return;
        e.preventDefault();
        const line = btn.closest('[data-line-key]');
        this.run(FW.cart.remove(line), () => fill(str().item_removed, { t: line.dataset.title }));
      });
      /* Fokus bleibt im offenen Drawer: das native Modal sperrt den Rest, die Falle fängt Tab über das Ende hinaus ab. Esc schließt (theme.js). */
      this.release = null;
      this.offs = [
        FW.on('dialog:open', ({ dialog }) => {
          if (dialog === this.dialog && FW.trapFocus && !this.release) this.release = FW.trapFocus(this.dialog);
        }),
        FW.on('dialog:close', ({ dialog }) => {
          if (dialog === this.dialog && this.release) {
            this.release();
            this.release = null;
          }
        }),
        FW.on('cart:added', (x) => this.added(x)),
        FW.on('cart:error', ({ message }) => this.fail(message)),
        FW.on('cart:render', () => !this.keep && this.fail('')),
        FW.on('cart:say', ({ message }) => this.say(message)),
      ];
    }

    disconnectedCallback() {
      (this.offs || []).forEach((off) => off());
      this.ready = false;
    }

    /* Ansage: im offenen Dialog über die Live-Region darin (die globale liegt hinter dem Modal), sonst global */
    say(msg) {
      if (!msg) return;
      if (!this.live || !this.dialog.open) return FW.announce(msg);
      this.live.textContent = '';
      requestAnimationFrame(() => (this.live.textContent = msg));
    }

    run(promise, msg) {
      this.fail('');
      promise.then(() => this.say(msg())).catch(() => {
        this.keep = true;
        FW.cart.refresh().catch(() => {}).finally(() => (this.keep = false));
      });
    }

    fail(text) {
      if (!this.error) return;
      this.error.textContent = text || '';
      this.error.hidden = !text;
    }

    added({ item, trigger }) {
      const title = (item && (item.product_title || item.title)) || '';
      this.say(fill(str().item_added, { t: title }));
      if (this.dataset.cartType === 'drawer' && !this.dialog.open) FW.openDialog(this.dialog, trigger);
    }
  }
  customElements.define('fw-cart-drawer', FwCartDrawer);
})();
